import { AntibioticsIdentifiedFarmer } from "@gtpl/shared-models/common-models";

export class FarmersDropDownDto {
    supplierId: number;
    supplierCode: string;
    supplierName: string;
    address?:string;
    mobileNumber?:string;
    antibioticsIdentifiedFarmer?:AntibioticsIdentifiedFarmer


    /**
     * 
     * @param supplierId number
     * @param supplierCode string
     * @param supplierName string
     * @param antibioticsIdentifiedFarmer string
     */
    constructor(supplierId: number, supplierCode: string, supplierName: string,address?: string, mobileNumber?:string,antibioticsIdentifiedFarmer?:AntibioticsIdentifiedFarmer, ) {
        this.supplierId = supplierId;
        this.supplierCode = supplierCode;
        this.supplierName = supplierName;
        this.address = address;
        this.mobileNumber = mobileNumber;
        this.antibioticsIdentifiedFarmer = antibioticsIdentifiedFarmer;
    }
}